function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.25 10V5.74403C4.25 5.63363 4.32242 5.5363 4.42816 5.50457L8.232 4.36342C8.30802 4.34062 8.39035 4.35526 8.45384 4.40288L8.90384 3.80288L8.45384 4.40288L14.4868 8.92758C15.03 9.335 15.1486 10.1016 14.7539 10.6541L12.0795 14.3983C11.6716 14.9693 10.8737 15.0928 10.3124 14.6718L4.35 10.2C4.28705 10.1528 4.25 10.0787 4.25 10Z",
  stroke: "#6A7786",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7.5,
  cy: 8,
  r: 1.5,
  fill: "#6A7786"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/label.18aaec78.svg";
export { SvgComponent as ReactComponent };